<!--
  Верстка адаптирована из шаблона:
  Файл: design-assets/themeforest_4DdWBZd0_education_online_courses_template_istudy (1)/istudy/courses-details.html
  Компонент: bd-course-instructors (строки 1044-1087)
  Стили: design-assets/themeforest_4DdWBZd0_education_online_courses_template_istudy (1)/istudy/assets/css/main.css
  Классы:
    - .bd-course-instructors (строка 18457)
    - .bd-course-instructors-content (строка 18461)
    - .bd-course-instructors-info (строка 18488)
    - .bd-course-instructors-rating (строка 18504)
    - .bd-course-instructors-course (строка 18517)
    - .bd-course-instructors-bio (строка 1080)
-->
<template>
  <div class="course-author">
    <div class="author-content">
      <div v-if="author.avatar" class="author-thumb">
        <img :src="author.avatar" :alt="author.name">
      </div>
      <div class="author-info">
        <div class="author-header">
          <h6 class="author-name">
            <a v-if="author.profileUrl" :href="author.profileUrl">{{ author.name }}</a>
            <span v-else>{{ author.name }}</span>
          </h6>
          <span v-if="author.designation" class="author-designation">{{ author.designation }}</span>
          <div v-if="author.description" class="author-description">
            <p>{{ author.description }}</p>
          </div>
          <div v-if="author.courseCreatedAt" class="course-created-date">
            <span class="date-label">{{ t('courseDetails.author.dateLabel') }}</span>
            <span class="date-value">{{ formatDate(author.courseCreatedAt) }}</span>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
export interface AuthorSocialLink {
  url: string
  icon: string
}

export interface AuthorStats {
  courses?: number
  students?: number
}

export interface Author {
  name: string
  avatar?: string
  designation?: string
  rating?: number
  reviewsCount?: number
  stats?: AuthorStats
  socialLinks?: AuthorSocialLink[]
  profileUrl?: string
  description?: string
  courseCreatedAt?: string | Date
}

interface Props {
  author?: Author
}

const props = withDefaults(defineProps<Props>(), {
  author: () => ({
    name: 'Author Name',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face',
    profileUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face'
  } as Author)
})

const author = computed(() => props.author || {
  name: 'Author Name',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face'
})

const formatDate = (date: string | Date | undefined): string => {
  if (!date) return ''
  
  const dateObj = typeof date === 'string' ? new Date(date) : date
  if (isNaN(dateObj.getTime())) return ''
  
  return new Intl.DateTimeFormat('uk-UA', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(dateObj)
}
</script>

<style scoped>
.course-author {
  padding: 20px 30px 25px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 40px;
}


.author-content {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 15px;
  gap: 20px;
}

.author-thumb {
  width: 170px;
  height: 170px;
  min-width: 170px;
  flex-shrink: 0;
}

.author-thumb img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
}

.author-info {
  flex: 1;
  min-width: 200px;
}

.author-header {
  margin-bottom: 12px;
}

.author-name {
  font-family: var(--font-inter);
  font-weight: 600;
  font-size: 18px;
  line-height: 1.3;
  color: #252840;
  margin: 0 0 8px 0;
}

.author-name a {
  color: #252840;
  text-decoration: none;
  transition: color 0.2s;
}

.author-name a:hover {
  color: #00CE9B;
}

.author-designation {
  display: block;
  font-family: var(--font-inter);
  font-size: 16px;
  color: #868D98;
  margin-top: 4px;
}

.author-description {
  margin-top: 12px;
}

.author-description p {
  font-family: var(--font-inter);
  font-size: 16px;
  line-height: 1.7;
  color: #252840;
  margin: 0;
}

.author-rating {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #868D98;
  margin-bottom: 12px;
}

.rating-icon {
  color: #FFC107;
}

.author-stats {
  display: flex;
  align-items: center;
  gap: 15px;
  color: #252840;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-inter);
  font-size: 14px;
}

.stat-item i {
  color: #868D98;
  font-size: 16px;
}

.author-social {
  margin-top: 12px;
}

.social-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.social-list li {
  list-style: none;
}

.social-list a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #fff;
  color: #252840;
  text-decoration: none;
  transition: all 0.2s;
}

.social-list a:hover {
  background: #00CE9B;
  color: #fff;
  transform: translateY(-2px);
}

.course-created-date {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-inter);
  font-size: 14px;
}

.date-label {
  color: #868D98;
  font-weight: 500;
}

.date-value {
  color: #252840;
  font-weight: 600;
}

@media (max-width: 767px) {
  .course-author {
    padding: 20px;
  }

  .author-thumb {
    width: 120px;
    height: 120px;
    min-width: 120px;
  }

  .author-name {
    font-size: 16px;
  }

  .author-designation {
    font-size: 14px;
  }

  .author-stats {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}

@media (max-width: 575px) {
  .author-content {
    flex-direction: column;
  }

  .author-thumb {
    width: 100px;
    height: 100px;
    min-width: 100px;
  }
}
</style>
